import * as React from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	getCurrency,
	getEntityById,
	getSearchStringForBackNavigationWithBackText,
	nullSafeGet,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import { Link } from 'react-router-dom';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import QuoteEditButton from '../quote_edit_button/QuoteEditButton';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { PROPOSALS_CRUD_ACTION_CREATORS } from '../../actions/proposals_actions';
import { updatePaginationQuotes } from '../../thunks/quotes_thunks_wrapper';
import { Form } from '@ant-design/compatible';
import {
	getQuotePathNameBackButton,
	getQuoteRestCrudThunksFromPath,
	isClientQuoteView,
	isSubcontractorQuoteViewLocation,
} from '../quote_utils/QuoteUtils';
import { getWorkOrderPath } from '../../utils/WorkOrderUtils';
import { QUOTE_STATUS_DISPLAY_NAMES } from '../../constants/QuoteStatuses';

const queryString = require('qs');
require('./SupplierQuotesDetailPage.less');

interface QuotesDetailPageState {}

class SupplierQuotesDetailPage extends React.Component<any, QuotesDetailPageState> {
	state = {
		sendQuoteByEmailModalVisible: false,
		documentsReceived: false,
		checkInImagesReceived: false,
		checkOutImagesReceived: false,
		documents: [],
		checkInImages: [],
		checkOutImages: [],
		loading: true,
		backLinkTo: '/supplier/quotes/overview/all',
		backLinkText: 'Back to quotes',
		basePath: 'supplier/quotes',
		fromTargetCollectionName: null,
	};

	constructor(props) {
		super(props);
	}

	formRefs = {
		sendQuoteByEmailForm: null,
	};

	componentDidMount() {
		const { getQuote, match, quote } = this.props;
		const quoteId = match.params.id;

		// Render the header off the cached record when we have one, but always follow up with the
		// single-proposal GET: budgets are hydrated only on the single-object read, so a record
		// cached from a list (retrieveAll) response carries none.
		if (quote && quote.id) {
			this.initialize(quote);
			getQuote(quoteId);
		} else {
			getQuote(quoteId).then((quote) => {
				this.initialize(quote);
			});
		}
	}

	initialize = (quote) => {
		const { location, userType, currentUser } = this.props;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({ fromTargetCollectionName: queryParams.targetCollectionName });
		}
		const basePath = getQuotePathNameBackButton(userType, currentUser, quote, false);
		if (queryParams.backlinkParams) {
			const { pathName, backLinkText, ...otherParams } = queryString.parse(
				queryParams.backlinkParams
			);
			const finalPath =
				pathName ||
				`/${getQuotePathNameBackButton(userType, currentUser, quote, true)}/overview/all`;
			this.setState({
				loading: false,
				basePath: basePath,
				backLinkTo: `${finalPath}?${new URLSearchParams(otherParams).toString()}`,
				...(backLinkText && { backLinkText }),
			});
		} else {
			this.setState({
				loading: false,
				basePath: basePath,
				backLinkTo: `/${getQuotePathNameBackButton(
					userType,
					currentUser,
					quote,
					true
				)}/overview/all`,
			});
		}
	};
	handleTabChange = (key) => {
		const { history, match } = this.props;
		const { basePath } = this.state;
		const quoteId = match.params.id;
		history.push(`/${basePath}/detail/${quoteId}/${key}`);
	};

	handleDelete = () => {
		const { history, deleteQuote, quote, location, userType } = this.props;
		const { basePath } = this.state;
		const hasContractorId = recordHasContractorId(quote);
		deleteQuote(quote, hasContractorId).then(() => {
			history.push(`/${basePath}/overview/all`);
		});
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const {
			quote,
			match,
			companyConfig,
			location,
			currentUser,
			cloneTargetCollection,
			history,
			proposals,
			updatePagination,
			userType,
		} = this.props;
		const { basePath } = this.state;
		const quoteId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			...(quote && quote.revisionChanges
				? [
						{
							key: 'revisions',
							name: 'Revisions',
						},
				  ]
				: []),
		];
		const getLink = (route) => {
			const searchString = getSearchStringForBackNavigationWithBackText('Back to quotes', location);
			const backUrl = `${route}${
				!!searchString ? `?backlinkParams=${encodeURIComponent(searchString)}` : ''
			}`;
			return backUrl;
		};

		const quoteActions = [
			<Link
				target={'_blank'}
				to={`/supplier/workOrders/detail/${nullSafeGet('workOrder.id', quote)}/${getWorkOrderPath(
					userType,
					currentUser,
					quote
				)}details`}
				style={{ marginRight: 16, marginBottom: 16 }}
			>
				<Button ghost={true}>
					View Work Order <i className="icons8-font icons8-external-link ml-2" />
				</Button>
			</Link>,
			<Link
				target={'_'}
				to={`/supplier/workOrders/detail/${nullSafeGet('workOrder.id', quote)}/${getWorkOrderPath(
					userType,
					currentUser,
					quote
				)}notes`}
				style={{ marginRight: 16, marginBottom: 16 }}
			>
				<Button ghost={true}>
					View Notes <i className="icons8-font icons8-external-link ml-2" />
				</Button>
			</Link>,
			<QuoteEditButton
				quote={quote}
				ghost={true}
				onClick={() => history.push(getLink(`/${basePath}/edit/${quoteId}`))}
				style={{ marginRight: 16, marginBottom: 16 }}
				isClientView={isClientQuoteView(quote, currentUser)}
			/>,
		];

		const currency = getCurrency({ workOrder: nullSafeGet('workOrder', quote) });
		return (
			<div className="quotesDetailPage">
				<DetailPageHeader
					exactPath={`/${basePath}/detail/:id`}
					redirectPath={`/${basePath}/detail/${quoteId}/details`}
					backLinkText={this.state.backLinkText}
					backLinkTo={this.state.backLinkTo}
					title={nullSafeGet('workOrder.title', quote)}
					subtitle={
						<>
							<div className="quotesDetailPage__subtitleRow">
								<div className="quotesDetailPage__subtitle">
									{QUOTE_STATUS_DISPLAY_NAMES[quote.status]}
								</div>
								<div className="quotesDetailPage__subtitle">
									{currency.format(quote.totalAfterTax)}
								</div>
							</div>
							{nullSafeGet('workOrder.location.name', quote) ? (
								<div className="body1" style={{ marginTop: 8 }}>
									{nullSafeGet('workOrder.location.name', quote)}
								</div>
							) : null}
						</>
					}
					actions={quoteActions}
					tabs={tabs}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
					childRoutes={this.props.childRoutes}
					tabsRightActions={() => (
						<NextPreviousButton
							key={this.state.fromTargetCollectionName}
							location={location}
							history={history}
							activeId={quote.id}
							getEnitityUrl={(id) => `/${basePath}/detail/${id}/details`}
							stateSlice={proposals}
							targetCollectionName={this.state.fromTargetCollectionName}
							updatePagination={updatePagination}
							cloneTargetCollection={cloneTargetCollection}
							entityName="quote"
						/>
					)}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	quote: getEntityById(ownProps.match.params.id, state.proposals),
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
	proposals: state.proposals,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getQuote: (id) =>
		dispatch(getQuoteRestCrudThunksFromPath(ownProps.userType, ownProps.location).readOne(id)),
	deleteQuote: (entity, hasContractorId) =>
		dispatch(
			getQuoteRestCrudThunksFromPath(ownProps.userType, ownProps.location).delete(
				entity,
				'id',
				null,
				true
			)
		),
	cloneTargetCollection: (from, to) =>
		dispatch(PROPOSALS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationQuotes('supplier')(
				false,
				ownProps.history,
				targetCollectionName,
				pagination,
				true
			)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierQuotesDetailPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
